import { Calendar } from 'lucide-react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/Button'
import { LocalizedLink } from '@/components/LocalizedLink'

interface TreatmentCTAProps {
  title: string
  subtitle?: string
  button?: string
  className?: string
}

export function TreatmentCTA({
  title,
  subtitle,
  button,
  className,
}: TreatmentCTAProps) {
  return (
    <section className={cn('bg-primary py-16 md:py-24', className)}>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-display text-3xl md:text-4xl font-semibold italic text-ink">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-4 text-lg text-ink/80 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
          <div className="mt-8">
            <LocalizedLink to="bookConsultation">
              <Button variant="primary-light">
                <Calendar className="w-4 h-4" />
                {button || 'Prenota una consulenza'}
              </Button>
            </LocalizedLink>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
